import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotfoundComponent } from './modules/shared/components/notfound/notfound.component';
import { LoginComponent } from './modules/shared/components/login/login.component';
import { UserProfileComponent } from './modules/shared/components/profile/profile.component';
import { AuthGuard } from './core/guards/auth.guard';
import { FocusLayoutComponent } from './modules/shared/components/focus-layout/focus-layout.component';
import { FlexLayoutComponent } from './modules/shared/components/flex-layout/flex-layout.component';
import { AlertedListComponent } from './modules/web/components/alerted-list/alerted-list.component';
import { CompanyDetailComponent } from './modules/web/components/company-detail/company-detail.component';
import { CompanyListComponent } from './modules/web/components/company-list/company-list.component';
import { RedirectComponent } from './modules/web/components/redirect/redirect.component';
import { SubscribePageComponent } from './modules/web/components/subscribe-page/subscribe-page.component';
import { FavoriteListComponent } from './modules/shared/components/favorite-list/favorite-list.component';
import { ResumeComponent } from './modules/shared/components/resume/resume.component';
import { JobDetailComponent } from './modules/shared/components/job-detail/job-detail.component';
import { HomeComponent } from './modules/web/components/home/home.component';
import { JobListComponent } from './modules/web/components/job-list/job-list.component';
import { CustomPreloadingStrategy } from './preload-strategy';
import { DaanComponent } from './modules/landings/components/daan/daan.component';
import { IframeComponent } from './modules/web/components/iframe/iframe.component';
import { TermsComponent } from './modules/web/components/terms/terms.component';
import { ContactUsComponent } from './modules/web/components/contact-us/contact-us.component';
import { JobBrowserComponent } from './modules/web/components/job-browser/job-browser.component';
import { PaymentDetailComponent } from './modules/shared/components/payment-detail/payment-detail.component';
import { AboutComponent } from './modules/web/components/about/about.component';
import { JobAdvertiseComponent } from './modules/web/components/job-advertise/job-advertise.component';
import { TestComponent } from './modules/web/components/test/test.component';
import { AgreementViewComponent } from './modules/shared/components/agreement-view/agreement-view.component';
import { SeekerJobPaymentComponent } from './modules/shared/components/seeker-job-payment/seeker-job-payment.component';
import { AssessmentTestListComponent } from './modules/web/components/assessment-test-list/assessment-test-list.component';
import { AssessmentTestComponent } from './modules/web/components/assessment-test/assessment-test.component';
import { RtwadListComponent } from './modules/web/components/rtwad-list/rtwad-list.component';
import { RtwadDetailComponent } from './modules/web/components/rtwad-detail/rtwad-detail.component';
import { RtwadFormComponent } from './modules/shared-panel/components/rtwad-form/rtwad-form.component';
import { RtwadSeekerListComponent } from './modules/web/components/rtwad-seeker-list/rtwad-seeker-list.component';
import { VerifyPhoneComponent } from './modules/shared-panel/components/verify-phone/verify-phone.component';

const routes: Routes = [
  {
    path: '', component: FlexLayoutComponent, children: [
      { path: '', component: HomeComponent, data: { homepage: true, hideBanner: true } },
      { path: '404', component: NotfoundComponent },
      { path: 'terms', component: TermsComponent, data: { title: 'توافق‌نامه کاربری' } },
      { path: 'about', component: AboutComponent, data: { title: 'درباره ما' } },
      { path: 'contact-us', component: ContactUsComponent, data: { title: 'تماس با ما' } },
      { path: 'browse', component: JobBrowserComponent, data: { title: 'عناوین شغلی' } },

      { path: 'job/search', redirectTo: 'job' },
      { path: 'job', component: JobListComponent, data: { title: 'فرصت های شغلی', reuse: true } },
      // { path: 'job/:id', component: JobDetailComponent, canActivate: [AuthGuard] },
      { path: 'matching/alert', component: AlertedListComponent },


      { path: 'company', component: CompanyListComponent, data: { title: 'لیست شرکت‌ها' } },
      { path: 'company/:code', component: CompanyDetailComponent, data: { title: 'پروفایل شرکت' } },

      { path: 'profile', component: UserProfileComponent, canActivate: [AuthGuard] },

      { path: 'admin', data: { hideFooter: true, hideBanner: true, panel: 'admin', title: 'پنل ادمین', noPreload: true }, loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule) },

      { path: 'favorite', component: FavoriteListComponent },

      { path: 'board', data: { noPreload: true }, loadChildren: () => import('./modules/board/board.module').then(m => m.BoardModule) },

      { path: 'monitoring', data: { noPreload: true }, loadChildren: () => import('./modules/monitoring/monitoring.module').then(m => m.MonitoringModule) },

      { path: 'assessment', component: AssessmentTestListComponent, data: { title: 'ارزیابی', hideBanner: true } },
      { path: 'assessment/:id', component: AssessmentTestComponent, data: { title: 'ارزیابی', hideBanner: true } },

      { path: 'discussion', loadChildren: () => import('./modules/message/message.module').then(m => m.MessageModule) },

      { path: 'agent', data: { noPreload: true }, loadChildren: () => import('./modules/agent/agent.module').then(m => m.AgentModule) },
			{
				path: 'ready-to-work', data: {title: 'آگهی‌های آماده به کار'},   children: [
					{path: '', component: RtwadListComponent},
					{path: ':id', component: RtwadDetailComponent},
				]
			}
    ]
  },
  {
    path: '', component: FocusLayoutComponent, children: [
      { path: 'karpasha/payment', component: SeekerJobPaymentComponent },
      { path: 'karpasha/payment/:id', component: SeekerJobPaymentComponent },
      { path: 'resume/:code', component: ResumeComponent },
      { path: 'exclusive-job/:adId', component: JobAdvertiseComponent },
      { path: 'test', component: TestComponent },
			{
				path:'account', data: {title: 'حساب کاربری'}, canActivate: [AuthGuard], children: [
					{
						path: 'rtw', canActivate: [AuthGuard], children: [
							{ path: '', component: RtwadSeekerListComponent, data: { title: 'آگهی‌های آماده به کار من ' } },
							{ path: 'post', component: RtwadFormComponent },
							{ path: ':id', component: RtwadFormComponent },
						]
					},
					{
						path: 'verify', canActivate: [AuthGuard], children: [
							{ path: 'phone', component:VerifyPhoneComponent , data: { title: 'تایید شماره تلفن همراه' } },
						]
					}
				]
			}
    ]
  },
  { path: 'job/:id', component: JobDetailComponent },
  { path: 'agreement/:id', component: AgreementViewComponent },
  { path: '', loadChildren: () => import('./modules/landings/landings.module').then(m => m.LandingsModule) },
  { path: 'employer', data: { title: 'کارفرمایان کارپیشه', hideBanner: true }, loadChildren: () => import('./modules/employer/employer.module').then(m => m.EmployerModule) },
  { path: 'seeker', data: { title: 'کارجویان کارپیشه' }, loadChildren: () => import('./modules/seeker/seeker.module').then(m => m.SeekerModule) },
  { path: 'login', data: { title: 'ورود' }, component: FocusLayoutComponent, children: [{ path: '', component: LoginComponent }] },
  { path: 'news', loadChildren: () => import('./modules/news/news.module').then(m => m.NewsModule) },
  { path: 'daan', data: { title: 'سامانه دان' }, component: FocusLayoutComponent, children: [{ path: '', component: DaanComponent }] },
  { path: 'karpasha', data: { noPreload: true, title: 'کارپاشا', hideBanner: true, hideFooter: true, panel: 'admin' }, loadChildren: () => import('./modules/karpasha/karpasha.module').then(m => m.KarpashaModule) },
  { path: 'r/:url', component: RedirectComponent },
  { path: 'r/job/:id', component: RedirectComponent },
  { path: 'r/job-f/:id', component: IframeComponent },
  { path: 'subscribe', component: SubscribePageComponent },
  { path: 'services', loadChildren: () => import('./modules/services/services.module').then(m => m.ServicesModule) },
  { path: 'chat', loadChildren: () => import('./modules/communication/communication.module').then(m => m.CommunicationModule) },
  { path: 'resource', data: { noPreload: true }, loadChildren: () => import('./modules/resource/resource.module').then(m => m.ResourceModule) },
  { path: 'crm', data: { noPreload: true }, loadChildren: () => import('./modules/crm/crm.module').then(m => m.CrmModule) },

  {
    path: 'payment', component: FocusLayoutComponent, children: [
      { path: '', component: PaymentDetailComponent },
      { path: ':id', component: PaymentDetailComponent }
    ]
  },
  {
    path: '**', component: FlexLayoutComponent, children: [
      { path: '', component: NotfoundComponent }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: CustomPreloadingStrategy,
    initialNavigation: 'enabledBlocking',
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
